/*@ngInject*/
const PeoplePickerRepository = function ($rootScope, $cacheFactory, coreConstant, submissionConstant, baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'loadUsersListCache';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.loadUsersList = function (submissionId) {
        let url = '/rest/User/people',
            config = {
                params: {
                    submissionId: submissionId
                }
            },
            cacheKey = submissionId;

        return this.get(cacheKey, url, config);
    };

    this.processResponseData = function (responseData) {
        function flattenPayload(payload) {
            let uniqueItems = new Set();
            return _.flatten(_.toArray(_.mapValues(payload, function (value, key) {
                return _.each(value, function (item) {
                    if (!uniqueItems.has(item.id + ':' + item.type)) {
                        uniqueItems.add(item.id + ':' + item.type)
                        item.group = key;
                        item.grouping = key;
                        item.name = !item.name ? item.firstName + ' ' + item.lastName : item.name;
                    }
                });
            })));
        }

        return flattenPayload(responseData);
    };

    $rootScope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
        this.clearCache();
    }.bind(this));

    $rootScope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
        let cache = $cacheFactory.get(this.getCacheName());
        if (cache) {
            cache.remove(submission.id);
        }
    }.bind(this));

};

angular.module('umCore')
    .service('peoplePickerRepository', PeoplePickerRepository);
